<label
  *ngIf="label"
  class="block text-sm cursor-text font-semibold mb-1"
  [class.text-sky-grey]="control.disabled"
  [class.text-sky-red]="control.touched && control.invalid"
  [class.text-sky-blue]="focused"
  >{{ label }}</label
>
<ng-select
  #ngSelect
  [class.focused]="focused"
  [class.error]="control.touched && control.invalid"
  [class.text-sky-grey]="control.disabled"
  [class.text-xs]="smallSized"
  [formControl]="dateControl"
  [placeholder]="placeholder"
  [multiple]="false"
  [clearable]="false"
  [closeOnSelect]="true"
  [items]="options"
  (change)="handleChange($event)"
  (focus)="focused = true"
  (blur)="focused = false"
  [searchable]="false"
>
  <ng-template ng-footer-tmp>
    <div class="px-2 py-4">
      <div class="flex justify-between">
        <form [formGroup]="getGroup('dateFrom')" class="date__block pr-2">
          <label class="flex items-center mb-4">
            <span class="pr-2 w-1/3">Od</span>
            <input [formControl]="getControl('dateFrom', 'date')" class="w-2/3 bg-white" type="date" />
          </label>
          <ng-container *ngIf="getControl('dateFrom', 'time') as timeFromControl">
            <label class="flex items-center">
              <span class="pr-2 w-1/3">Godz</span>
              <input type="time" [formControl]="timeFromControl" class="w-2/3" />
            </label>
            <p *ngIf="timeFromControl.dirty && timeFromControl.errors?.msg" class="text-sm text-sky-red">
              {{ timeFromControl.errors!.msg }}
            </p>
          </ng-container>
        </form>
        <form [formGroup]="getGroup('dateTo')" class="date__block pl-2">
          <label class="flex items-center mb-4">
            <span class="pr-2 w-1/3">Do</span>
            <input [formControl]="getControl('dateTo', 'date')" class="w-2/3 bg-white" type="date" />
          </label>
          <ng-container *ngIf="getControl('dateTo', 'time') as timeToControl">
            <label class="flex items-center">
              <span class="pr-2 w-1/3">Godz</span>
              <input
                [formControl]="timeToControl"
                (select)="shouldTestInput = false"
                (blur)="shouldTestInput = true"
                type="time"
                class="w-2/3"
              />
            </label>
            <p *ngIf="timeToControl.dirty && timeToControl.errors?.msg" class="text-sm text-sky-red">
              {{ timeToControl.errors!.msg }}
            </p>
          </ng-container>
        </form>
      </div>
      <ng-container *ngIf="customDateForm.invalid">
        <p class="text-sky-red max-w-fit pt-4">
          Nie można wybrać daty początku zakresu wcześniejszej niż data końca i na odwrót.
        </p>
        <p class="text-sky-red max-w-fit">Ustaw prawidłowy zakres.</p>
      </ng-container>

      <button [disabled]="customDateForm.invalid" class="sky-btn-sky-blue block ml-auto mt-4" (click)="setCustomDate()">
        Ustaw
      </button>
    </div>
  </ng-template>
</ng-select>
